module.exports = __webpack_public_path__ + "fonts/la-solid-900.36fc2979.woff2";